import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 7026 13498"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke-width:195.63}.fil0{fill:none}.fil1{fill:#fefefe}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1939336471600">
        <path
          d="M809 98h5408c391 0 711 319 711 711v5408c0 391-320 711-711 711H809c-391 0-711-320-711-711V809C98 417 418 98 809 98z"
          className="fil1-bg stroke1"
          style={{
            strokeWidth: 195.63,
          }}
        />
        <path
          d="M3513 1206c342 0 619 277 619 619s-277 620-619 620-619-278-619-620 277-619 619-619zM1540 4517c299 0 541 242 541 541s-242 541-541 541-541-242-541-541 242-541 541-541zM5486 4517c299 0 541 242 541 541s-242 541-541 541-541-242-541-541 242-541 541-541zM550 8031h5962c51 0 93 41 93 93v487c0 51-42 93-93 93H550c-51 0-93-42-93-93v-487c0-52 42-93 93-93z"
          className="fil1-bg stroke1"
          style={{
            strokeWidth: 195.63,
          }}
        />
        <path
          d="M1558 5280c162 0 295 132 295 294v2457h-589V5574c0-162 132-294 294-294z"
          className="fil1-bg stroke1"
          style={{
            strokeWidth: 195.63,
          }}
        />
        <path
          d="M1485 8704h4092v1617c0 848-663 1550-1496 1612l70 672H2875l71-675c-817-79-1461-772-1461-1609V8704z"
          className="fil1-bg stroke1"
          style={{
            strokeWidth: 195.63,
          }}
        />
        <path
          d="m3314 11478 293-830h-599l739-1136-292 830h599l-740 1136z"
          className="fil1-bg stroke1"
          style={{
            strokeWidth: 195.63,
          }}
        />
        <path
          d="M5504 5280c162 0 294 132 294 294v2457h-589V5574c0-162 133-294 295-294z"
          className="fil1-bg stroke1"
          style={{
            strokeWidth: 195.63,
          }}
        />
        <path
          d="M3287 12605h452v796h-452z"
          className="fil1-bg stroke1"
          style={{
            strokeWidth: 195.63,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
